import React, {Component} from 'react';
import LoadingSpinner from "../Utils/LoadingSpinner";
import Moment from "react-moment";

function Partner(props) {
    let approval;
    if ( props.approved ){
        approval = <span> Approved <Moment unix>{props.approved_at}</Moment> </span>
    }else{
        //
        approval = <span> Approval requested <Moment unix>{props.requested_at}</Moment>
                <button onClick={ () => props.submitApproval(props.id, true)}>Approve</button>
                <button onClick={ () => props.submitApproval(props.id, false)}>Deny</button>
            </span>
    }
    return (
        <div> {props.name} {props.email} {approval}</div>
    );
}

class PartnersList extends Component {
    state = {
        loading: true
    };

    componentDidMount() {
        this.fetchPartnersList();
    }

    fetchPartnersList() {
        this.props.simGps.getPartnersList(
            (success, result) => {
                if (success) {
                    this.setState({loading: false, partners: result})
                } else {
                    this.setState({loading: false})
                }
            }
        );
    }

    submitApproval = (partner_id, approved) => {
        console.log('Submitting the approval');
        this.props.simGps.submitPartnerApproval(partner_id, approved, () => {
            this.fetchPartnersList();
        });
    };

    render() {
        if (this.state.loading) {
            return (<LoadingSpinner text="Retrieving agreements ..."/>);
        } else {
            return (
                this.state.partners.map( partner => (
                    <Partner key={partner.id} {...partner} submitApproval={this.submitApproval}/>
                ) )
            );
        }
    }
}

export default PartnersList;
